export const REFERRAL_TOKEN_COOKIE_KEY = 'referral_token'
